import type { ThunkAction, ThunkDispatch } from 'redux-thunk';
import type { Action, Dispatch } from 'redux';
import type { AccommodationState } from './index';
import type { GetServerSidePropsContext } from 'next';
import type { IncomingMessage, ServerResponse } from 'node:http';
import type { UnleashToggles } from './unleash';

export enum ApiActionStatus {
    NOT_STARTED = 'NOT_STARTED',
    PENDING = 'PENDING',
    ERROR = 'ERROR',
    OK = 'OK',
}

export type ApiResponse<T> = {
    url: string;
    status?: number;
    statusText?: string;
    data?: T;
    // biome-ignore lint/suspicious/noExplicitAny: This was set before biome was added
    error?: any;
    requestTime?: number;
    headers?: Headers;
};

export interface Facet {
    value: string;
    displayValue?: string;
    count?: number;
    disabled?: boolean;
}

export type ThunkResult<ReturnType = void> = ThunkAction<ReturnType, AccommodationState, unknown, Action<string>>;
export type ThunkDispatchFunc = ThunkDispatch<AccommodationState, undefined, Action>;

// Use this if dispatch is needed as a prop in a component (instead of mapDispatchToProps)
export interface ThunkDispatchProp {
    dispatch: Dispatch<Action> & ThunkDispatchFunc;
}

export type OverrideValues<K, T> = { [P in keyof K]: T };

export interface NextPageRequest extends IncomingMessage {
    query?: GetServerSidePropsContext['query'];
    cookies?: Partial<{ [key: string]: string }>;
    ip?: string;
}

export interface NextPageResponse extends ServerResponse {
    locals?: Locals;
}

export interface Locals {
    loginId?: number | null;
    spidId?: number | null;
    userToken?: string;
    finnToken?: string;
    authCookies?: string;
    hasLegalBasis?: boolean;
    unleash?: UnleashToggles;
    unleashId?: string;
}

export type SanitizedLocals = Omit<Locals, 'userToken' | 'finnToken' | 'authCookies'>;

export type FetchHeaders = Record<string, string>;

export type FetchOptions = {
    method?: string;
    headers?: FetchHeaders;
    signal?: AbortSignal;
    internal?: boolean;
    plain?: boolean;
    authCookies?: string;
};

export type Orientation = 'horizontal' | 'vertical';
